<template>
  <div :class="$style.settings">
    <div v-for="access in accesses" :key="access.id" :class="$style.setting">
      <span :class="$style.title">{{access.title}}</span>
      <toggle-button :value="app.accesses.includes(access.id)"
                     :color="{checked: '#09E56E', unchecked:'#dadada'}"
                     :sync="true"
                     :width="45"
                     :height="27"
                     :class="$style.toggleBtn"
                     @change="$emit('change', access.id)"
      />
    </div>
    <button :class="$style.closeBtn" @click="$emit('closeSettings')">Вернуться назад</button>
  </div>
</template>

<script>

export default {
  name: 'settings',
  props: {
    app: Object,
    accesses: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    changeAccess() {
    },
  },
}
</script>
<style lang="scss" module src="./settings.scss"></style>
